import React from "react";
import { Loader } from "@whatslly/ui-components/Loader";
import styles from "./LoadingPage.module.scss";

export const LoadingPage = () => {
  return (
    <div className={styles.container}>
      <Loader />
    </div>
  );
};
